
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M17.75 4H18a2 2 0 012 2v13a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h.25","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('rect',{attrs:{"x":"9","y":"3","width":"6","height":"3","rx":"1","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"fill":"#593289","d":"M12 9h13v14H12z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M18 13.25c-2.083 0-3.75 1.713-3.75 3.75A3.734 3.734 0 0018 20.75c2.037 0 3.75-1.667 3.75-3.75 0-2.037-1.713-3.75-3.75-3.75z","stroke":"#fff","stroke-width":"1.408","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M21.75 17h1.5M18 13.25v-1.5M18 22.25v-1.5M12.75 17h1.5","stroke":"#fff","stroke-width":"1.408","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('circle',{attrs:{"cx":"18","cy":"17","r":".75","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    